//FAQ section
(function($) {
	"use strict";
	// console.log('ue');
	$('.section-faqs').each(function () {
		// console.log('aa');
		$(this).find('ul.accordion li .accordion__title').on('click', function(){
			//expand accordion
			// console.log('cic');
			$(this)
				.closest('li')
				.toggleClass('js-is-open')
				.find('.accordion__content')
				.toggleClass('js-hidden');
		});
	});

})(jQuery);